import { CommonModule } from '@angular/common';
import { Component, inject, ViewChild, ViewContainerRef } from '@angular/core';
import { Router } from '@angular/router';
import {
  CcdlDialogService,
  DialogRef,
  DropdownList,
  NavList,
} from '@cpm-pr1618001/ng-design-lib';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';
import { UserDialogView } from '../landing-page.modal';
import { LandingPageFacade } from '../store/facade/landing-page.facade';
import { UserContainerComponent } from '../user/user.container.component';
import { HeaderComponent } from './header.component';

@Component({
  selector: 'fm-header',
  imports: [CommonModule, HeaderComponent],
  templateUrl: './header.container.component.html',
  styleUrl: './header.container.component.scss',
})
export class HeaderContainerComponent {
  private readonly router = inject(Router);
  private readonly landingPageFacade = inject(LandingPageFacade);
  private readonly ccdlDialogService = inject(CcdlDialogService);

  @ViewChild('userDialogVCR', { read: ViewContainerRef })
  userDialogVCR: ViewContainerRef;

  userDialogView$: Observable<UserDialogView> =
    this.landingPageFacade.activeSignButton$;
  mobileNavigationMenu$: Observable<DropdownList[]> =
    this.landingPageFacade.getMobileNavigationMenu$;
  desktopNavigationMenu$: Observable<NavList[]> =
    this.landingPageFacade.getDesktopNavigationMenu$;

  openDialog(): void {
    const dialogRef: DialogRef = this.ccdlDialogService.open(
      UserContainerComponent,
      {
        vcr: this.userDialogVCR,
      },
    );

    (dialogRef.instance as UserContainerComponent).requestNavigateToView
      .pipe(take(1))
      .subscribe((view: UserDialogView) => {
        this.userDialogView(view);
      });

    dialogRef.result.catch((data: boolean) => {
      this.dialogOutsideClickEvent();
    });
  }

  userDialogView(event: UserDialogView) {
    this.landingPageFacade.setActiveSignButton(event);
    if (event !== UserDialogView.CLOSE) {
      this.openDialog();
    }
  }

  dialogOutsideClickEvent(): void {
    this.landingPageFacade.setActiveSignButton(UserDialogView.CLOSE);
  }
}
